module.exports = __webpack_public_path__ + "img/icon_map_51_on_111.e04f0d8b.png";